import VueGoogleMaps from '@fawmi/vue-google-maps'
import '@assets/css/index.css'
import '@assets/css/style.css'

import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { createPinia } from 'pinia'
import VueApexCharts from 'vue3-apexcharts'
import { getItemLocalStorage } from '@utils/helper.utils.js'

import App from './App.vue'
import router from './router'
import resetStore from './store/reset.store'
import en from './lang/en'
import fr from '@/lang/fr.json'
import countries from '@/utils/countries'
import { createSentryPlugin } from '@pkg/sentry-frontend-wrapper'
import { getDefaultTags, initSentryLogger } from '@/services/sentryService'

const pinia = createPinia()
pinia.use(resetStore)
const app = createApp(App)

const sentryPlugin = createSentryPlugin({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    () => Sentry.browserTracingIntegration(), // ✅ performance
    () => Sentry.replayIntegration(),
  ],
  environment: import.meta.env.VITE_ENVIRONMENT,
  release: import.meta.env.VITE_RELEASE_VERSION,
  // turn on performance if needed
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // trackComponents: true,
  beforeSendTransaction(transaction) {
    const defaultTags = getDefaultTags()
    transaction.tags = { ...defaultTags, ...transaction.tags }
    return transaction
  },
  beforeSendSpan(span) {
    span.data = {
      ...span.data,
      'app.version': '1.0.15',
    }
    return span
  },
})

app.use(sentryPlugin)

const logger = app.config.globalProperties.$sentryLogger

initSentryLogger(logger)

export const i18n = createI18n({
  // something vue-i18n options here ...
  legacy: false, // you must set `false`, to use Composition API
  locale:
    getItemLocalStorage('locale') ||
    countries[import.meta.env.VITE_INSTITUATION].default_locale_lang,
  fallbackLocale: 'en',
  messages: {
    en,
    fr,
  },
})

app.use(pinia)
app.use(i18n)
app.use(router)
app.use(VueGoogleMaps, {
  load: {
    key: import.meta.env.VITE_GOOGLE_API_KEY,
    libraries: 'places',
  },
})

app.use(VueApexCharts)

app.mount('#app')
